export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-950 dark-section">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Left: Phone mockup */}
          <div className="flex-shrink-0 w-full max-w-[320px] lg:max-w-[360px]">
            <div className="relative mx-auto w-[240px] md:w-[280px]">
              <div className="rounded-[2.5rem] bg-foreground-900 p-3 shadow-2xl shadow-black/40">
                <div className="rounded-[1.8rem] overflow-hidden bg-background-950 aspect-[9/19]">
                  <img
                    src="https://readdy.ai/api/search-image?query=Mobile%20phone%20screenshot%20of%20a%20movie%20streaming%20app%20interface%20in%20dark%20theme%20with%20warm%20red%20accents%2C%20showing%20movie%20posters%20grid%20layout%2C%20clean%20modern%20UI%20design%2C%20cinematic%20color%20scheme%20with%20dark%20background%20and%20golden%20highlights%2C%20Chinese%20text%20interface&width=600&height=1267&seq=app-mockup-dsxy-01&orientation=portrait"
                    alt="大师兄影视移动端界面预览"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              {/* Floating badges */}
              <div className="absolute -top-3 -right-6 bg-accent-500 text-white text-xs font-bold px-3 py-1.5 rounded-full shadow-lg shadow-accent-500/30 whitespace-nowrap hidden md:block">
                新上线
              </div>
              <div className="absolute -bottom-3 -left-6 bg-primary-500 text-white text-xs font-bold px-3 py-1.5 rounded-full shadow-lg shadow-primary-500/30 whitespace-nowrap hidden md:block">
                免费下载
              </div>
            </div>
          </div>

          {/* Right: Content */}
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading font-bold text-2xl md:text-4xl text-white mb-4">
              移动观影 · 随时随地享受大片
            </h2>
            <p className="text-foreground-500 text-sm md:text-base leading-relaxed mb-8 max-w-[520px] mx-auto lg:mx-0">
              大师兄影视移动端适配完美，支持 iOS 与 Android 双平台。无论是在通勤路上、午休间隙还是旅行途中，
              打开手机就能畅享高清影视内容。离线缓存功能让你在没有网络时也能继续追剧，观影记录自动同步。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3 mb-8">
              {['高清流畅', '离线缓存', '投屏支持', '夜间模式', '智能推荐'].map((tag) => (
                <span
                  key={tag}
                  className="inline-block px-4 py-2 rounded-full text-xs font-medium bg-white/10 text-white/70 border border-white/10 whitespace-nowrap"
                >
                  {tag}
                </span>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button className="inline-flex items-center gap-2 bg-white text-foreground-950 font-semibold px-7 py-3 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer text-sm hover:bg-white/90">
                <i className="ri-apple-line text-lg"></i>
                App Store 下载
              </button>
              <button className="inline-flex items-center gap-2 border border-white/30 hover:border-white/60 text-white font-medium px-7 py-3 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer text-sm">
                <i className="ri-android-line text-lg"></i>
                Android 下载
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}